import React from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';
import { get, orderBy, find } from 'lodash';
import { Link } from '@bd/bdcore-named-routes';
import { getPlanRouteProps } from '@bd/bdcore-data/build/Plans/selectors';
import { Image } from '@bd/bdcore-utilities';
import withData from '@bd/bdcore-data';

function getCommunityModelProperty(community, plan, field) {
  let communityMatch = null;
  if (community) {
    communityMatch = find(plan.communities, ['community', community._id]);
  }
  return get(communityMatch, `communityModelProperties.${field}`, get(plan, field));
}

class PlanCard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showMenu: false,
    };

    this.handleToggle = this.handleToggle.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.setToggleRef = this.setToggleRef.bind(this);
  }

  componentWillMount() {
    document.addEventListener('click', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  }

  setToggleRef(node) {
    if (this.toggleRef) {
      this.toggleRef.removeEventListener('click', this.handleToggle);
    }

    this.toggleRef = node;
    if (this.toggleRef) {
      this.toggleRef.addEventListener('click', this.handleToggle);
    }
  }

  handleToggle(event) {
    event.preventDefault();

    this.setState({
      showMenu: !this.state.showMenu,
    });
  }

  handleClickOutside(event) {
    if (
      this.toggleRef
      && !this.toggleRef.isSameNode(event.target)
      && !this.toggleRef.contains(event.target)
      && this.state.showMenu
    ) {
      this.setState({
        showMenu: false,
      });
    }
  }

  render() {
    const { community, plan, communities, areaName } = this.props;
    const { showMenu } = this.state;
    return (
      <div className="col-sm-12 col-md-6 col-lg-4 col-xl-3 mb-3">
        <div className="card Home">
          <Link name="plan-detail" params={getPlanRouteProps(plan, { community })}>
            {
              plan.elevationPhotos[0] &&
              <Image
                className="card-img-top"
                src={get(plan, 'elevationPhotos[0].contentUrl', '')}
                alt={get(plan, 'name')}
                width={450}
                height={300}
                exact
              />
            }
            {
              !plan.elevationPhotos[0] &&
              <img src="/images/comming-soon.jpg" alt="Comming Soon" className="card-img-top" />
            }
          </Link>
          {
            plan.headline &&
            <div className="headline">{plan.headline}</div>
          }
          <div className="card-body">
            <div className="row no-gutters">
              <div className="col-12">
                <h4 className="address">
                  <Link name="plan-detail" className="address" params={getPlanRouteProps(plan, { community })}>
                    {plan.name}
                  </Link>
                </h4>
              </div>
            </div>
          </div>
          <ul className="list-group">

            <li className="list-group-item d-none">
              <span className="price">
                { numeral(plan.price).format('$0,0') }
              </span>
            </li>

            { (plan.stories > 0 || plan.garages > 0) &&
              <li className="list-group-item inline">
                { plan.stories > 0 && <div>Stories: {getCommunityModelProperty(community, plan, 'stories')}</div> }
                { plan.garages > 0 && <div>Garage: {getCommunityModelProperty(community, plan, 'garages')}-Car</div> }
              </li>
            }
            <li className="list-group-item">
              <div className="row text-center details">
                <div className="col">
                  <img src="/images/icon-beds-blue.svg" alt="Bed Icon" />
                  <div><span>{getCommunityModelProperty(community, plan, 'beds')}</span> Beds</div>
                </div>
                <div className="col">
                  <img src="/images/icon-baths-blue.svg" alt="Bath Icon" />
                  <div>
                    <span>{getCommunityModelProperty(community, plan, 'bathsFull')}</span> Baths
                  </div>
                </div>
                <div className="col">
                  <img src="/images/icon-sqft-blue.svg" alt="Square Feet Icon" /><br />
                  <div><span>{numeral(getCommunityModelProperty(community, plan, 'sqft')).format('0,0')}</span> SQFT</div>
                </div>
              </div>
            </li>
            {
              communities.length > 0 &&
              <li className="list-group-item">
                Where can I find this Plan? <br />
                <a href ref={this.setToggleRef}>
                  {`${communities.length} ${(communities.length) > 1 ? 'Communities' : 'Community'}`}
                  {
                    areaName !== 'All' &&
                    ` in ${areaName}`
                  }
                </a>
                {
                  showMenu &&
                  <div className="plan-comm-list-dropdown">
                    <ul>
                      {
                        orderBy(communities, 'name').map(planComm => (
                          <li key={planComm._id}>
                            <Link name="plan-detail" params={getPlanRouteProps(plan, { community: planComm })}>
                              {get(planComm, 'name')} {' '}
                              <span>{get(planComm, 'address.addressLocality')}, {get(planComm, 'address.addressRegion')}</span>
                            </Link>
                          </li>
                        ))
                      }
                    </ul>
                  </div>
                }
              </li>
            }
            {
              communities.length === 0 &&
              <li className="list-group-item">
                Where can I find this Plan? <br />
                <span >
                  0 Communities
                </span>
              </li>
            }
          </ul>
          <div className="card-footer">
            <div className="row">
              <div className="col text-right">
                <Link name="plan-detail" params={getPlanRouteProps(plan, { community })}>
                  View Detail<img src="/images/icon-circle-arrow-blue.svg" alt="Circle Arrow Icon" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


PlanCard.propTypes = {
  community: PropTypes.object,
  plan: PropTypes.object.isRequired,
  communities: PropTypes.arrayOf(PropTypes.object),
  areaName: PropTypes.string,
};

PlanCard.defaultProps = {
  community: undefined,
  communities: [],
  areaName: 'All',
};

export default withData({
  community: true,
  plan: true,
  communities: true,
}, {
  required: {
    plan: true,
  },
})(PlanCard);



// WEBPACK FOOTER //
// ./src/pages/Plans/PlanCard.js